export const calcStay = (inDate, outDate) =>
  Math.ceil((new Date(outDate) - new Date(inDate)) / (1000 * 60 * 60 * 24));

export const formatRoomTypes = (roomDetails = []) => {
  if (!roomDetails.length) return "-";
  return roomDetails
    .map((room) => {
      const qty = Number(room.quantity) > 1 ? ` (x${room.quantity})` : "";
      return `${room.name || "-"}${qty}`;
    })
    .join(", ");
};

export const RESERVATION_EXPORT_HEADERS = [
  "Check In",
  "Check Out",
  "Stay",
  "Hotel",
  "Room Type",
  "Guest",
  "Phone No",
  "Source",
];

export const mapReservationsToExportRows = (reservations = []) =>
  reservations.map((item) => [
    item.checkIn || "-",
    item.checkOut || "-",
    `${calcStay(item.checkIn, item.checkOut)} nights`,
    item.hotelName || "-",
    formatRoomTypes(item.roomDetails),
    item.firstName || "-",
    item.mobile || "-",
    item.source || "-",
  ]);
